export const CHAT_MESSAGE_MAX_LENGTH = 1000;

const URL_PATTERN = /https?:\/\/[^\s<>"]+[^\s<>"'.,;:!?)\]}]/g;

const HTML_ESCAPES: Record<string, string> = {
  "'": '&#39;',
  '"': '&quot;',
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
};

const escapeHtml = (value: string): string => value.replace(/[&<>"']/g, char => HTML_ESCAPES[char]);

const linkify = (line: string): string => {
  let html = '';
  let lastIndex = 0;
  for (const match of line.matchAll(URL_PATTERN)) {
    const url = escapeHtml(match[0]);
    html += `${escapeHtml(line.slice(lastIndex, match.index))}<a href="${url}">${url}</a>`;
    lastIndex = match.index + match[0].length;
  }
  return html + escapeHtml(line.slice(lastIndex));
};

export const chatTextToHtml = (text: string): string =>
  `<p>${text.trim().split(/\r?\n/).map(linkify).join('<br>')}</p>`;

export const htmlToPlainText = (value: string): string => {
  if (!/<[a-z][\s\S]*>/i.test(value)) {
    return value;
  }
  const document = new DOMParser().parseFromString(
    value.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p[^>]*>/gi, '\n'),
    'text/html',
  );
  return document.body.textContent ?? '';
};
